<script lang="ts">
  import { accessoriesStore } from '$lib';
  import IntersectionObserver from 'svelte-intersection-observer';
  export let className = '';

  let node: HTMLDivElement;
  export let inter = false;

  // embeddedShop is true when we visit Accessories page from mobile version using IFrame, in this case we don't want to use intersectingObserver
  const embeddedShop = $accessoriesStore.embeddedShop;
</script>

{#if embeddedShop}
  <slot />
{:else}
  <!--Trigger-->
  <IntersectionObserver once element={node} bind:intersecting={inter} threshold={0}>
    <div bind:this={node} class={className}>
      {#if inter}
        <slot />
      {/if}
    </div>
  </IntersectionObserver>
{/if}

<style lang="scss" ||lang="postcss">
</style>
